export const PAYMENT_IDS = {
  PAYPAL: 'paypal',
  GCGE: 'gc-ge',
};

export const PAYMENT_GATEWAY_STATES = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
};
